module.exports = __webpack_public_path__ + "img/node_level3.cb23538e.png";